import { CalculatorKind } from 'types/learningMaterials';

export const calculatorKinds: CalculatorKind[] = ['CALC_NUM', 'CALC_UD', 'CALC_BR', 'CALC_CD', 'CALC_SD'];
